// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2R4n3","empty":"ModalGraph_empty__2cOLy"};